import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { FC, ReactNode } from 'react';

import { MessageViewPageType } from 'APP/main/ChatView/Messages/Messages.types';
import { ChatMessage } from 'STORE/Messages/Message/ChatMessage/ChatMessage';

import { disableQuoteAttrs } from '../Message.constants';
import { MessageSelect } from '../components/MessageSelect/MessageSelect';
import { useSystemMessageLayoutPresenter } from './SystemMessageLayout.presenter';
import styles from './SystemMessageLayout.styles.m.css';
import { SystemMessageMenu } from './SystemMessageMenu/SystemMessageMenu';

interface SystemMessageLayoutProps {
  message: ChatMessage;
  className?: string;
  children: ReactNode;
  messageViewPageType: MessageViewPageType;
}

export const SystemMessageLayout: FC<SystemMessageLayoutProps> = observer((props) => {
  const { message, className, children, messageViewPageType } = props;

  const presenter = useSystemMessageLayoutPresenter(message);

  const menuMessage = presenter.isShowMenu ? (
    <SystemMessageMenu
      key="system-message-menu"
      message={message}
      className={styles.systemMessageMenu}
      messageViewPageType={messageViewPageType}
    />
  ) : null;

  return (
    <div className={classNames(styles.container, className)}>
      <div className={styles.innerContainer}>
        {presenter.withMeInAdmins && <div className={styles.menuPlaceholder}>{menuMessage}</div>}
        <div {...disableQuoteAttrs}>{children}</div>
        {presenter.withMeInAdmins && <div className={styles.menuPlaceholder} />}
      </div>
      {presenter.withMeInAdmins && (
        <MessageSelect
          key="select"
          message={message}
          onMessageSelect={presenter.onMessageSelect}
          labelClassName={styles.selectLabel}
        />
      )}
    </div>
  );
});
